/**
 * @description :: Function to add additional Carousel Banner and static images within the website landing page
 */
import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Center,
  ColorInput,
  Text,
  Select,
  ActionIcon, 
  Stack,
  Checkbox, 
} from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto, IconUpload, IconVideo, IconX, IconPlus } from "@tabler/icons-react";
import classes from "./add.module.css";
import { RowDataBannerWeb } from "./types";

interface AddBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddBanner: (newBannerData: RowDataBannerWeb) => void;
}

const AddBannerModal: React.FC<AddBannerModalProps> = ({
  isOpen,
  onClose,
  onAddBanner,
}) => {
  const [newBanner, setNewBanner] = useState<RowDataBannerWeb>({
    id: "",
    title: "",
    descs: "",
    img: "",
    imgMobile: "",
    buttonTitle: "",
    newTab: false,
    darkMode: false,

    // color: "",
    type: "",
    route: "",
    show: false,
    action: "Edit",
  });
  const imageDropzoneRef = useRef<() => void>(null);
  const imageMobileDropzoneRef = useRef<() => void>(null);


  const [descs, setDescs] = useState<string[]>([])
  const [descInput, setDescInput] = useState<string>('')

  useEffect(()=>{
    setNewBanner({ ...newBanner, descs: JSON.stringify(descs) })
  },[descs.length])

  const handleImageUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
      setNewBanner({ ...newBanner, img: file });
    }
  };

  const handleImageMobileUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
      setNewBanner({ ...newBanner, imgMobile: file });
    }
  };

  const handleAddBanner = () => {

    if(descs.length === 0){
        alert("Please fill in all the required fields");
        return;
    }

    // Check if any required fields are empty
    if (!newBanner.title || !newBanner.img || !newBanner.imgMobile || !newBanner.route || !newBanner.buttonTitle || !newBanner.type) {
      alert("Please fill in all the required fields");
      return;
    }

    onAddBanner(newBanner);

    // Clear inputs and reset state
    setNewBanner({
      id: "",
      title: "",
      descs: "",
    img: "",
    imgMobile: "",
    buttonTitle: "",
    newTab: false,
    darkMode: false,
    //   color: "",
    type: "",
    route: "",
      show: false,
      action: "Edit",
    });
    setDescs([])
    setDescInput('')
    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewBanner({
      id: "",
      title: "",
      descs: "",
    img: "",
    imgMobile: "",
    buttonTitle: "",
    newTab: false,
    darkMode: false,
    //   color: "",
    type: "",
        route: "",
      show: false,
      action: "Edit",
    });
    setDescs([])
    setDescInput('')
    // Call the onClose function
    onClose();
  };

  const addDesc = () => {
    if(descInput.trim().length < 1){
        alert("Please enter description");
        return;
    }
    descs.push(descInput.trim())
    setDescInput('')
}

const removeDesc = (index: number) => {
    setDescs(item=> item.filter((s,i)=>(i != index)))
}

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Banner
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
    >

    <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <Dropzone
        onDrop={handleImageUpload}
        accept={["image/*"]}
        openRef={imageDropzoneRef}
      >
        <div className={classes.imageContainer}>
          {newBanner.img ? (
            <img
              src={URL.createObjectURL(newBanner.img)}
              alt="Image"
              className={classes.imageSize}
            />
          ) : (
            <p>
              <IconPhoto />
            </p>
          )}
        </div>
      </Dropzone>
      <Group>
        <Button
          onClick={() => imageDropzoneRef.current?.()}
          className={classes.imageButton}
        >
          <IconPhoto />
          Upload Image
        </Button>
      </Group>


      <Text className={classes.Text}>
        Image Mobile <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <Dropzone
        onDrop={handleImageMobileUpload}
        accept={["image/*"]}
        openRef={imageMobileDropzoneRef}
      >
        <div className={classes.imageContainer}>
          {newBanner.imgMobile ? (
            <img
              src={URL.createObjectURL(newBanner.imgMobile)}
              alt="Image"
              className={classes.imageSize}
            />
          ) : (
            <p>
              <IconPhoto />
            </p>
          )}
        </div>
      </Dropzone>
      <Group>
        <Button
          onClick={() => imageMobileDropzoneRef.current?.()}
          className={classes.imageButton}
        >
          <IconPhoto />
          Upload Image
        </Button>
      </Group>

      <TextInput
        label="Title"
        placeholder="Input title"
        mb="sm"
        maxLength={255}
        value={newBanner.title}
        onChange={(event) =>
          setNewBanner({ ...newBanner, title: event.currentTarget.value })
        }
      />

        <Stack gap={4}>
        {descs.length > 0 ? <Text className={classes.Text}>Descriptions</Text> : null}
        {descs.map((item, i)=>(
            <div key={i} style={{display: 'flex', gap: 10, width: '100%'}}>
                <div style={{flex: 1}}>
                <TextInput
                    // disabled={createvenueMutation.isLoading}
                    value={item}
                    readOnly
                />
                </div>
                <ActionIcon onClick={() => removeDesc(i)} size='lg' variant="outline" color='red'>
                    <IconX size={20} />
                </ActionIcon>
            </div>
        ))
        }
        </Stack>

        <Text className={classes.Text}>Add Description</Text>
        <div style={{display: 'flex', gap: 10, width: '100%'}}>
            <div style={{flex: 1}}>
                <TextInput
                // label="Terms"
                placeholder="Input desc"
                mb="sm"
                maxLength={255}
                value={descInput}
                onChange={(event) =>
                    setDescInput(event.currentTarget.value)
                }
                />
            </div>
            <ActionIcon onClick={() => addDesc()} size='lg' variant="outline" color='green'>
                <IconPlus size={20} />
            </ActionIcon>
        </div>

      {/* <ColorInput
        label="Color"
        placeholder="Select a color"
        mb="sm"
        value={newBanner.color}
        onChange={(color) => setNewBanner({ ...newBanner, color: color })}
      /> */}

    <TextInput
        label="Button Title"
        placeholder="Input title"
        mb="sm"
        maxLength={255}
        value={newBanner.buttonTitle}
        onChange={(event) =>
          setNewBanner({ ...newBanner, buttonTitle: event.currentTarget.value })
        }
      />

      <Select
        label="Banner Type"
        placeholder="Select banner type"
        data={[
          { value: 'carousel', label: 'Carousel' },
          { value: 'prebuiltPC', label: 'Prebuilt PC' },
          { value: 'pcBuilder', label: 'PC Builder' },
          { value: 'customPC', label: 'Custom PC' },
        ]}
        value={newBanner.type}
        onChange={(value) => {
          if (value) {
            if (value == 'prebuiltPC'){
              setNewBanner({ ...newBanner, type: value, route: 'prebuild/all'});
            } else if (value == 'pcBuilder') {
              setNewBanner({ ...newBanner, type: value, route: 'builder/quick'});
            } else if (value == 'customPC'){
              setNewBanner({ ...newBanner, type: value, route: 'builder/custom'});
            } else {
              setNewBanner({ ...newBanner, type: value , route: ''});
            }
          }
        }}
        mb="sm"
      />

    <TextInput
        label="Route"
        placeholder="Input route"
        mb="sm"
        maxLength={255}
        value={newBanner.route}
        disabled={newBanner.type !== 'carousel'} 
        onChange={(event) =>
          setNewBanner({ ...newBanner, route: event.currentTarget.value })
        }
      />

    <Checkbox
      checked={newBanner.newTab}
      onChange={(event) => setNewBanner({...newBanner, newTab: event.currentTarget.checked})}
      label="New tab?"
      mb="sm"
    />

    <Checkbox
      checked={newBanner.darkMode}
      onChange={(event) => setNewBanner({...newBanner, darkMode: event.currentTarget.checked})}
      label="Dark mode?"
      mb="sm"
    />


      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddBanner} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddBannerModal;
